var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCoursesMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 0L0.333008 8L5.66634 10.9067V18.9067L14.9997 24L24.333 18.9067V10.9067L26.9997 9.45333V18.6667H29.6663V8L14.9997 0ZM24.093 8L14.9997 12.96L5.90634 8L14.9997 3.04L24.093 8ZM21.6663 17.32L14.9997 20.96L8.33301 17.32V12.36L14.9997 16L21.6663 12.36V17.32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoursesMenu);
export default __webpack_public_path__ + "static/media/icon_courses_menu.ff0281743e14a5fc3b89f0ce7276e4bb.svg";
export { ForwardRef as ReactComponent };